export const ABROAD = 'ABROAD';
export const REMOTE = 'REMOTE';
